import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {IssueTemplateChooser} from '@github-ui/issues-shared/IssueTemplateChooser'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'

import {issueNewChooseRoute} from './issue-new-choose-route'
import {issuesLayoutRoute, layoutCurrentUser} from './issues-layout-route'

export function IssueNewChoose() {
  const payload = useRouteQuery(issueNewChooseRoute, 'mainQuery')
  const layoutPayload = useRouteQuery(issuesLayoutRoute, 'mainQuery')

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  const repository = data?.repository
  if (!repository) {
    return null
  }

  return (
    <BaseAnalyticsWrapper category="Repository Issue Create" appName="issues">
      <IssueTemplateChooser repository={repository} currentUser={layoutCurrentUser(layoutPayload.data)} />
    </BaseAnalyticsWrapper>
  )
}
